"use client";

import { Location } from "iconsax-reactjs";
import { Skeleton } from "@/components/ui";
import { useCityFromCoordinates } from "@/hooks/useCityFromCoordinates";

interface ShopLocationProps {
  latitude?: string | number | null;
  longitude?: string | number | null;
}

export const ShopLocation = ({ latitude, longitude }: ShopLocationProps) => {
  const {
    cityName,
    query: { isLoading, error },
  } = useCityFromCoordinates({ latitude, longitude });

  if (isLoading) {
    return (
      <div className="flex items-center gap-1">
        <Location size={16} />
        <Skeleton variant="muted" className="h-4 w-20" />
      </div>
    );
  }

  if (error || !cityName) {
    return null;
  }

  return (
    <div className="flex items-center gap-1">
      <Location size={16} />
      <span className="text-sm">{cityName}</span>
    </div>
  );
};
